import styles from './_albumComponent.module.scss'
import Image from 'next/legacy/image'
import Link from 'next/link'
import { albumPath } from '../utils/routeHelpers'
import { Album } from '../__generated__/graphql'
import TextScrollContainer from '../utils/containers/TextScrollContainer'

interface AlbumProps {
  album: Album
}

const AlbumComponent: React.FC<AlbumProps> = ({ album }) => {
  return (
    <article className={styles.album}>
      <div>
        <Link href={albumPath(album)} prefetch={false} className={styles.title}>
          <figure>
            <div className="is-square">
              <Image src={album.cover.medium} alt={album.name} layout="fill" />
            </div>
          </figure>
          <TextScrollContainer>
            <strong>{album.name}</strong>
          </TextScrollContainer>
        </Link>
      </div>
    </article>
  )
}

export default AlbumComponent
